import React from 'react';
import {
  Grid,
  Paper,
  Stack,
  Button,
  Typography,
  Box,
  Select,
  MenuItem,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { ICompanyViewModel } from 'Interfaces/ICompaniesConfig';
import { truncateText } from 'functions/truncateText';

export interface ModuleActionButtonProps {
  label: string;
  infoTitle: string;
  infoText: string;
  loading: boolean;
  icon: React.ReactElement;
  tokenValid: boolean;
  onClick: () => void;
}

export const TokenModuleButton: React.FC<ModuleActionButtonProps> = ({
  label,
  infoTitle,
  infoText,
  loading,
  tokenValid,
  icon,
  onClick,
}) => (
  <Grid item xs={12} sx={{ mb: 1 }}>
    <Paper 
      elevation={1} 
       color={tokenValid ? 'warning' : 'success'}
      sx={{ borderRadius: 2, width: '100%',  }}>
      <Stack direction='row' spacing={0} sx={{ m: 0 }}>
        <Grid item xs={2} sx={{}}>
          <Button
            sx={{ height: 76, width: '100%', borderRadius: 2 }}
            variant='contained'
            color={!tokenValid ? 'warning' : 'success'}
            onClick={onClick}
            startIcon={
              loading ? (
                <CircularProgress size={36} color='inherit' />
              ) : (
                <Box sx={{ color: 'inherit', mt: 1.2 }}>
                  {React.cloneElement(icon, { color: 'inherit' })}
                </Box>
              )
            }
          >
            <Typography sx={{ width: '100%', p: 0, m: 0, fontSize: 16 }}>
              {label}
            </Typography>
          </Button>
        </Grid>
        <Grid item xs={7} sx={{ pl: 2 }}>
          <Typography sx={{ width: '100%', p: 0, m: 0, fontSize: 16 }}>
            {infoTitle}
          </Typography>
          <Typography sx={{ color: 'primary.text', fontSize: 16 }}>
            {infoText.split('\n').map((line, i) => (
              <React.Fragment key={i}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </Typography>
        </Grid>     
      </Stack>
    </Paper>
  </Grid>
);
